import { Numeric5BoxIcon } from './Numeric5BoxIcon';

/**
 * author: Google
 * id 1F91841C-B56D-486E-8113-187E28F1E53A
 * name numeric-5-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-5-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number5BoxIcon = Numeric5BoxIcon;
export default Number5BoxIcon